import { AXIOS } from "@/AXIOS/http-common";

const state = {
  list: [],
};

const actions = {
  async getOldRecordWhitelist(context) {
    return await AXIOS.get("/admin/user/permissions/by-permission/record_unlock").then((response) => {
      context.commit("setOldRecordWhitelist", response.data);
    });
  },
};

const mutations = {
  setOldRecordWhitelist(state, data) {
    state.list = data;
  },
};

const getters = {
  GETOLDRECORDWHITELIST: (state) => state.list,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
